const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @components
const WizardError = require('components/commons/wizardError/wizardError');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

const CardChargeErrorStep = props => {
    const { immCard, messageObject } = props;
    const title = messageObject ? formatText(messageObject.title) : formatText('cardChargeError-errorTitle');
    const message = messageObject ? messageObject.message : 'cardChargeError-errorMessage';
    const injectedStrings = messageObject ? messageObject.injectedStrings : [];
    const cardAlias = immCard.get('alias').get('current');
    const goBackButtonLabel = formatText('cardChargeError-backToCard', [cardAlias]).toUpperCase();
    const goBackLink = messageObject ? messageObject.goBackLink : `/myprofile/cards/${immCard.get('cardId')}/movements`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: goBackLink
    }

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10">
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} />
                    </div>
                    <div className="col-xs-7">
                        <FormattedText value={message} injectedStrings={injectedStrings} />
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

CardChargeErrorStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    messageObject: PropTypes.object.isRequired
};

module.exports = CardChargeErrorStep;